// extracted by mini-css-extract-plugin
export default {"account":"Settings_account__BSY0d","links":"Settings_links__oAxVw"};